import React from 'react';

import classNames from 'classnames';
import format from 'date-fns/format';

const formatDateForDateInput = date => format(date, 'yyyy-MM-dd');

export const DateInput = ({ className, value, onChange }) => (
  <input
    className={classNames('border border-border-dark rounded px-2', className)}
    type="date"
    value={value}
    onChange={onChange}
    max={formatDateForDateInput(new Date())}
  />
)

export default DateInput;
